import React, { useState } from 'react';
import Button, { BOOKING_HREF } from '../Button/Button';
import './Navbar.css';
import logoWeb from '../../assets/logos/LogoWeb.png';
import logoMobile from '../../assets/logos/Logo FreshStart mobile.png';

const serviceLinks = [
  { label: 'Landscape Design & Installation', href: '/services/landscape-design' },
  { label: 'Complete Yard Care', href: '/services/complete-yard-care' },
];

const navLinks = [
  { label: 'Our Work', href: '/our-work' },
  { label: 'About', href: '/about' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <a href="/" className="navbar__logo">
          <img src={logoWeb} alt="Fresh Start Landscaping and Maintenance" className="navbar__logo-web" />
          <img src={logoMobile} alt="Fresh Start Landscaping and Maintenance" className="navbar__logo-mobile" />
        </a>
        <div className="navbar__links">
          <div className="navbar__dropdown">
            <a href="/#services" className="navbar__link navbar__link--trigger">
              Services
            </a>
            <div className="navbar__dropdown-menu" role="menu" aria-label="Services">
              {serviceLinks.map(link => (
                <a key={link.href} href={link.href} className="navbar__dropdown-link" role="menuitem">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
          {navLinks.map(link => (
            <a key={link.label} href={link.href} className="navbar__link">
              {link.label}
            </a>
          ))}
          <Button variant="nav" href={BOOKING_HREF}>Start a Project</Button>
        </div>
        <button
          className="navbar__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          type="button"
        >
          <span className={`navbar__hamburger-icon ${menuOpen ? 'open' : ''}`}>
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>
      <div className={`navbar__drawer ${menuOpen ? 'navbar__drawer--open' : ''}`}>
        <a href="/#services" className="navbar__drawer-link" onClick={closeMenu}>
          Services
        </a>
        <div className="navbar__drawer-sub">
          {serviceLinks.map(link => (
            <a
              key={link.href}
              href={link.href}
              className="navbar__drawer-sublink"
              onClick={closeMenu}
            >
              {link.label}
            </a>
          ))}
        </div>
        {navLinks.map(link => (
          <a key={link.label} href={link.href} className="navbar__drawer-link" onClick={closeMenu}>
            {link.label}
          </a>
        ))}
        <Button variant="primary" href={BOOKING_HREF}>Book a Free Consultation</Button>
      </div>
    </nav>
  );
};

export default Navbar;
